import React from 'react';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
  NavLink,
  NavLinkProps,
} from 'react-router-dom';
import { normalizePath } from '../lib/paths';

type ToProp = RouterLinkProps['to'];

function normalizeTo(to: ToProp): ToProp {
  if (typeof to === 'string') {
    return normalizePath(to);
  }
  if (to && typeof to === 'object' && 'pathname' in to && to.pathname) {
    return { ...to, pathname: normalizePath(to.pathname) };
  }
  return to;
}

export type LinkProps = RouterLinkProps;

/** React Router Link that accepts Gatsby-style trailing-slash paths. */
export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, ...props }, ref) => (
    <RouterLink ref={ref} to={normalizeTo(to)} {...props} />
  )
);

Link.displayName = 'Link';

export type AppNavLinkProps = Omit<NavLinkProps, 'className'> & {
  className?: string;
  activeClassName?: string;
};

/** NavLink with Gatsby-style `activeClassName` support. */
export const AppNavLink = React.forwardRef<HTMLAnchorElement, AppNavLinkProps>(
  ({ to, className, activeClassName, ...props }, ref) => (
    <NavLink
      ref={ref}
      to={normalizeTo(to)}
      className={({ isActive }) =>
        [className, isActive && activeClassName].filter(Boolean).join(' ')
      }
      {...props}
    />
  )
);

AppNavLink.displayName = 'AppNavLink';
